export enum RawDataFormat {
  CSV = "CSV",
  JSON = 'JSON'
}
